import { render } from "./AddNewProduct.vue?vue&type=template&id=14bc2808&scoped=true"
import script from "./AddNewProduct.vue?vue&type=script&lang=js"
export * from "./AddNewProduct.vue?vue&type=script&lang=js"

import "./AddNewProduct.vue?vue&type=style&index=0&id=14bc2808&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14bc2808"]])

export default __exports__